/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseDictDataAnyOf } from './genericApiResponseDictDataAnyOf';

export type GenericApiResponseDictData = GenericApiResponseDictDataAnyOf | null;
